import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useMarkPlaybookAsFavorite = () => {
  const { call, isLoading } = useApiPrivateRequest();

  const markPlaybookAsFavorite = async (id: string) => {
    await call(`/playbooks/${id}/favorite`, "POST");
  };

  return {
    markPlaybookAsFavorite,
    isLoading,
  };
};
